import {
  Outlet,
  createFileRoute,
  notFound,
  retainSearchParams,
} from '@tanstack/react-router'
import { ReactFlowProvider } from '@xyflow/react'
import * as v from 'valibot'

import { Heading } from '@masterplandev/ui'

import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'
import { PageContainer } from '@/app/manager/Layout'
import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { FEATURE_LICENSES_TREE } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import { usersQueries } from '@/http/api/users'
import { LicensesTree } from '@/licenses-tree/components/LicensesTree'

const validateSearch = v.object({
  status: v.optional(v.array(v.picklist(['active', 'pending', 'deactivated']))),
})

export const Route = createFileRoute('/company/_management/licenses-structure')(
  {
    head: () => ({
      meta: [
        {
          title: buildPageTitle({
            titleKey: 'page-title-licenses-structure',
          }),
        },
      ],
    }),
    validateSearch,
    search: {
      middlewares: [retainSearchParams(['status'])],
    },
    beforeLoad: ({ context }) => {
      if (!context.user?.features.includes(FEATURE_LICENSES_TREE)) {
        throw notFound()
      }
    },
    loader: ({ context: { queryClient, user } }) => {
      if (user) {
        queryClient.prefetchQuery(usersQueries.usersDetail(user.id))
      }
      queryClient.prefetchQuery(usersQueries.usersList({ size: 100000 }))
    },
    component: LicensesStructurePage,
    pendingComponent: LoadingIndicator,
  },
)

function LicensesStructurePage() {
  return (
    <CompanyPage
      overflowY="auto"
      display="flex"
      flexDirection="column"
      h="full"
      gap="10">
      <PageContainer pt="10">
        <Heading size="h3">Licenses Structure</Heading>
      </PageContainer>
      <ReactFlowProvider>
        <LicensesTree />
        <Outlet />
      </ReactFlowProvider>
    </CompanyPage>
  )
}
